import * as React from 'react';
import { Route, Routes as RoutesSwitch } from 'react-router-dom';

import { LayerRenderEvent } from '../../../../layers/LayerManager';
import { LayerWidget } from '../../../../layers/LayerWidget';
import { Routes, useJourneyNavigation } from '../../../../routes';
import { EditDeveloperInviteDialogWidget } from './EditDeveloperInviteDialogWidget';
import { EditParentDeveloperDialogWidget } from './EditParentDeveloperDialogWidget';

export type EditDeveloperLayerWidgetProps = {
  route: Routes;
};

export const EditDeveloperLayerWidget: React.FC<EditDeveloperLayerWidgetProps> = (props) => {
  const handler = useJourneyNavigation(props.route);

  return (
    <LayerWidget
      options={{ userCanExit: false, withBackdrop: true }}
      renderLayer={(event: LayerRenderEvent) => {
        const onSubmitOrCancel = () => {
          handler.navigate(Routes.MANAGE_USERS, { org_id: handler.params.org_id });
          event.layer.dispose();
        };

        return (
          <RoutesSwitch>
            <Route
              path={Routes.CREATE_DEV}
              element={<EditParentDeveloperDialogWidget onSubmitOrCancel={onSubmitOrCancel} />}
            />
            <Route
              path={Routes.EDIT_USER}
              element={<EditParentDeveloperDialogWidget onSubmitOrCancel={onSubmitOrCancel} />}
            />
            <Route
              path={Routes.EDIT_INVITE}
              element={<EditDeveloperInviteDialogWidget onSubmitOrCancel={onSubmitOrCancel} />}
            />
          </RoutesSwitch>
        );
      }}
    />
  );
};
